import type { NodeId } from 'web';
import type { FlowGraph } from '../FlowGraph';

/**
 * Resolves a URL suitable for workflow poster (same basis as {@link NodeViewer}): file-backed
 * images use `url`; computed/canvas previews call WASM `exportNodeRender` (expensive).
 *
 * Intended for on-demand use (e.g. user clicks "Set as cover"). Do not use from render or
 * `useSyncExternalStore` selectors — that would re-run PNG/base64 export every frame.
 */
export function resolveNodePreviewImagePosterUrl(graph: FlowGraph, nodeId: NodeId): string | undefined {
  if (graph.getNodeType(nodeId) === 'extract_video_frame') {
    const img = graph.wasm.call((wasm) => wasm.exportNodeRender(nodeId, 'result', 2048));
    return img?.data;
  }

  const evaluated = graph.evaluateNode(nodeId);
  if (evaluated?.type !== 'image') {
    return undefined;
  }

  const val = evaluated.value;
  if (val.type === 'computed') {
    return graph.wasm.call((wasm) => wasm.exportNodeRender(nodeId))?.data;
  }
  if (val.type === 'file') {
    return val.url;
  }
  return undefined;
}
